import { render, staticRenderFns } from "./DynamicRequestForm.vue?vue&type=template&id=732d9e42"
import script from "./DynamicRequestForm.vue?vue&type=script&lang=js"
export * from "./DynamicRequestForm.vue?vue&type=script&lang=js"
import style0 from "./DynamicRequestForm.vue?vue&type=style&index=0&id=732d9e42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports